<template>
	<span @click="clicked" :style="settings.styles" :class="['qd-toggler', isActive ? 'active' : '', settings.class, disabled ? 'disabled' : '']">
		<label>{{ settings.title }}</label>
	</span>
</template>

<script>
	import _ from 'lodash'

	export default {
		emits: ['update:modelValue'],
		props: {
			options: { type: Object, required: true },
			modelValue: { type: [Boolean, String], required: true },
			tabindex: { type: [Number, String] },
			startup: { type: Boolean, default: false },
			disabled: { type: Boolean, default: false },
		},
		data() {
			return {
				isActive: false,
				settings: {
					title: 'Toggler',
					class: '',
					value: '',
				}
			}
		},
		watch: {
			options: {
				deep: true,
				immediate: true,
				handler(val) {
					this.settings = _.merge(this.settings, val)
					this.isActive = this.refreshIsActive()
				}
			}
		},
		methods: {
			clicked() {
				if (this.disabled) return
				this.isActive = !this.isActive
				this.$emit('update:modelValue', this.isActive)
			},
			refreshIsActive() {
				if (this.modelValue === true)
					return true

				return this.modelValue === this.settings.value
			},
		}
	}
</script>

<style lang="less">
	@import "../styles/toggler.less";
</style>